/* eslint-disable react/no-array-index-key */
import compact from 'lodash/compact';
import get from 'lodash/get';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'semantic-ui-react';

import PDFModal from '../../../components/cms/FilesBlock/components/PDFModal';
import { isPDF } from '../../../components/cms/utils';
import { UserType } from '../../../core/users/users.types';
import { ensureArray } from '../../../utils/arrayUtils';
import { UserFileConfig, ensureFileConfigs } from '../../v2/utils';
import './UserFiles.scss';

type UserFilesProps = {
  user: UserType;
  fileConfig?: UserFileConfig | UserFileConfig[];
  buttonProps?: Record<string, any>;
};

type FileType = {
  uri: string;
};

const UserFiles: FC<UserFilesProps> = ({ user, fileConfig, buttonProps }) => {
  const { t } = useTranslation();
  const [pdfToShow, setShowPDF] = useState<FileType | null>(null);

  const fileConfigs = ensureFileConfigs(fileConfig);
  if (!fileConfigs.length) return null;

  const handleFileClick = (fileValue: FileType) => {
    if (isPDF(fileValue.uri)) {
      setShowPDF(fileValue);
    } else {
      window.open(fileValue.uri, '_blank');
    }
  };

  const groups = compact(
    fileConfigs.map((config) => {
      const { field, icon, label } = config;
      const fileArray = ensureArray(get(user, field)).filter((f) => f.uri);
      if (!fileArray.length) return null;

      const hasMultiple = fileArray.length > 1;
      return (
        <div key={field} className="button-group button-group--files">
          {fileArray.map((fileValue, index) => (
            <Button
              key={index}
              primary
              basic
              compact
              {...buttonProps}
              onClick={() => handleFileClick(fileValue)}
            >
              <Icon name={icon || 'download'} />
              {label || t('btn.download')} {hasMultiple ? ` (${index + 1})` : undefined}
            </Button>
          ))}
        </div>
      );
    }),
  );

  if (!groups.length) return null;

  return (
    <>
      {groups}
      {pdfToShow && <PDFModal file={pdfToShow} onClose={() => setShowPDF(null)} />}
    </>
  );
};

export default UserFiles;
